import { combineReducers } from 'redux';

import User from './User/';

const Reducer = combineReducers({ User });

export default Reducer;
